module.exports = __webpack_public_path__ + "img/s2m-loader-big.420df326.gif";